import React from "react";

const ShareYourStory = () => {
  return <div>ShareYourStory</div>;
};

export default ShareYourStory;
